import { render, staticRenderFns } from "./AddDocument.vue?vue&type=template&id=5ad11264&scoped=true&"
import script from "./AddDocument.vue?vue&type=script&lang=js&"
export * from "./AddDocument.vue?vue&type=script&lang=js&"
import style0 from "./AddDocument.vue?vue&type=style&index=0&id=5ad11264&scoped=true&lang=css&"
import style1 from "./AddDocument.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad11264",
  null
  
)

export default component.exports